/**
 * Blurs the input when enter is pressed.
 *
 * @unstable
 */

import { Directive, ElementRef, inject } from '@angular/core';

/**
 * Automatically blurs an input if enter is pressed.
 */
@Directive({
  selector: 'input[enterBlur], textarea[enterBlur]',
  standalone: false,
  host: {
    '(keyup.enter)': 'onKeyUp()',
  },
})
export class EnterBlur {
  private elRef = inject<ElementRef<HTMLElement>>(ElementRef);

  onKeyUp(): void {
    this.elRef?.nativeElement.blur();
  }
}
